import * as _ from "lodash";
import {atom, task, computed} from 'nanostores';
import { jsonOrFail } from './utils.jsx';
import { $productConfig } from "./Config.jsx";


export const $dataReady = atom(null);
export const $downloadedDictionary = atom({});


export const $stdEducationDocumentTypes = computed(
    $downloadedDictionary,
    ($) => (
        $.stdEducationDocumentTypes
    )
);


export const $stdEducationPrioSubjects = computed(
    $downloadedDictionary,
    ($) => (
        $.stdEducationPrioSubjects
    )
);


export const $grades = computed(
    $downloadedDictionary,
    ($) => (
        $.grades
    )
);


export const $stdLanguages = computed(
    $downloadedDictionary,
    ($) => (
        $.stdLanguages
    )
);


export const $stdHealthGroups = computed(
    $downloadedDictionary,
    ($) => (
        _.map(
            $.stdHealthGroups,
            (v) => ({value:v, label:v})
        )
    )
);


export const $isFirstPoDict = computed(
    $downloadedDictionary,
    ($) => (
        _.map(
            $.isFirstPo,
            (v)=>({value:v, label:v})
        )
    )
);


export const $specializationsDict = computed(
    $downloadedDictionary,
    ($) => (
        $.specializations
    )
);


export const $identificationDocumentTypes = computed(
    $downloadedDictionary,
    ($) => (
        $.identificationDocumentTypes
    )
);


export const $additionalStatusTypes = computed(
    $downloadedDictionary,
    ($) => (
        $.additionalStatusTypes
    )
);


export const $representativePersonList = computed(
    $downloadedDictionary,
    ($) => (
        $.representativePersonList
    )
);


export const loadDictionaries = (url) => {
    $dataReady.set(false);
    const config = $productConfig.get();
    return task(async () => (
        await fetch(url)
        .then(jsonOrFail)
        .then(async (edata) => {
            return fetch(config.siteconfig_url)
            .then(jsonOrFail)
            .then((odata) => {
                const merged = _.merge(edata, odata)

                $downloadedDictionary.set(merged);
                $dataReady.set(true);
            });
        })
        .catch((err) => {
            console.error("failed load dictionaries", url, err);
            $downloadedDictionary.set({});
            $dataReady.set(null);
            throw err;
        })
    ));
}